import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import {
  LocationEnvironmentGQL,
  LocationEnvironmentQuery,
  LocationEnvironmentOrderByInput,
  LocationEnvironmentsPaginatedGQL,
  LocationEnvironmentsPaginatedQuery,
} from '@generated/sammathnaur.graphql'
import { firstValueFrom } from 'rxjs'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class LocationsEnvironmentsService {
  public readonly filterForm = new FormGroup({
    locationId: new FormControl(),
    archived: new FormControl(false as 'all' | false | true),
  })

  public orderBy = signal<LocationEnvironmentOrderByInput>(LocationEnvironmentOrderByInput.NameAsc)
  public limit = signal<number>(25)
  public offset = signal<number>(0)

  public readonly locationEnvironmentsPaginatedGQL = inject(LocationEnvironmentsPaginatedGQL)
  public readonly locationEnvironmentGQL = inject(LocationEnvironmentGQL)

  public async searchPage(): Promise<Apollo.QueryResult<LocationEnvironmentsPaginatedQuery>> {
    const { locationId, archived } = this.filterForm.value

    const observable$ = this.locationEnvironmentsPaginatedGQL.fetch({
      variables: {
        where: {
          locationId,
          archived: archived === 'all' ? undefined : archived,
        },
        limit: this.limit(),
        offset: this.offset(),
        orderBy: this.orderBy(),
      },
    })

    return firstValueFrom(observable$)
  }

  public async searchOne(id: string): Promise<Apollo.QueryResult<LocationEnvironmentQuery>> {
    const observable$ = this.locationEnvironmentGQL.fetch({ variables: { id } })
    return firstValueFrom(observable$)
  }
}
